import React from "react"
import { ButtonBase } from "@mui/material"

const ImageButton = (props) => {
  return (
    <ButtonBase disableRipple id={props.id} onClick={props.onClick}>
      {props.children}
    </ButtonBase>
  )
}

export default ImageButton
